import styled from 'styled-components';
import Box, { Flex } from '@spotnana/pixel-react/dist/Box';
import Typography from '@spotnana/pixel-react/dist/Typography';

export const Row = styled(Flex)`
  justify-content: space-between;
  align-items: center;
  margin-bottom: 10px;
  margin-top: 10px;
`;

export const SubTextContainer = styled(Flex)<{ subTextLeft?: string; subTextRight?: string }>`
  justify-content: ${({ subTextLeft, subTextRight }) => {
    if (subTextLeft && subTextRight) {
      return 'space-between';
    }
    if (subTextLeft) {
      return 'flex-start';
    }
    if (subTextRight) {
      return 'flex-end';
    }
    return 'space-between';
  }};
`;

export const BreakupDivider = styled(Box)`
  border: 1px solid ${({ theme }) => theme.colors.border.regular};
  height: 0px;
  margin: 16px 0px;
`;

export const OnlyValueContainer = styled(Flex)`
  justify-content: flex-end;
  margin-bottom: 10px;
`;

export const OnlyValueText = styled(Typography).attrs({ fontWeight: 'semiBold', variation: 'body' })`
  color: ${({ theme }) => theme.colors.text.label};
  margin-top: 10px;
  margin-bottom: 10px;
`;

export const TooltipTextContainer = styled(Flex)`
  align-items: center;
`;

export const TooltipText = styled(Typography).attrs({ color: 'text.semiBold' })`
  padding: 12px;
`;

export const TooltipIconContainer = styled(Flex)`
  width: 18px;
  height: 24px;
  margin-left: 8px;
  align-items: center;
  justify-content: center;
`;
